/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiResetPasswordForm
 */
export interface InternalApiResetPasswordForm {
    /**
     * 
     * @type {string}
     * @memberof InternalApiResetPasswordForm
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiResetPasswordForm
     */
    token: string;
}

/**
 * Check if a given object implements the InternalApiResetPasswordForm interface.
 */
export function instanceOfInternalApiResetPasswordForm(value: object): value is InternalApiResetPasswordForm {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function InternalApiResetPasswordFormFromJSON(json: any): InternalApiResetPasswordForm {
    return InternalApiResetPasswordFormFromJSONTyped(json, false);
}

export function InternalApiResetPasswordFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiResetPasswordForm {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'token': json['token'],
    };
}

export function InternalApiResetPasswordFormToJSON(json: any): InternalApiResetPasswordForm {
    return InternalApiResetPasswordFormToJSONTyped(json, false);
}

export function InternalApiResetPasswordFormToJSONTyped(value?: InternalApiResetPasswordForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'token': value['token'],
    };
}

